import { UserPlus } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyStateProps {
  isAdmin: boolean;
  onAddClick: () => void;
}

export function EmptyState({ isAdmin, onAddClick }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      {isAdmin ? (
        <div className="text-center space-y-4">
          <p className="text-gray-500 mb-4">لا توجد بيانات لعرضها</p>
          <Button onClick={onAddClick} className="hover:bg-secondary">
            <UserPlus className="h-4 w-4 ml-2" />
            إضافة عضو جديد
          </Button>
        </div>
      ) : (
        <p className="text-gray-500">لا توجد بيانات لعرضها</p>
      )}
    </div>
  );
}